// Section 17: priority group 'Teachers'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function teachers(_config: Config) {
  return definePriorityGroup({
    id: 'teachers',
    label: 'Teachers',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter((p) => p.job === 'teacher')
        .map((p) => p.id),
  });
}
